<template>
  <div>
    <Breadcrumb >
      <BreadcrumbItem>首页</BreadcrumbItem>
      <BreadcrumbItem :to="{name: 'meeting-list'}">活动列表</BreadcrumbItem>
      <BreadcrumbItem :to="{name: 'sign-list'}">报名管理</BreadcrumbItem>
      <BreadcrumbItem>报名详情</BreadcrumbItem>
    </Breadcrumb>
    <div class="single-page ivu-article">
      <Alert :type="alertType" show-icon>
        <h2>报名状态：{{ getStatusText(sign.signStatus) }} </h2>
        <span slot="desc">
           <span v-if="sign.signStatus === 1 || sign.signStatus === 2">审核日期：{{ formatDate(sign.auditDate) }}</span>
          <br/>
          <span v-if="sign.signStatus === 2">拒绝原因：{{ sign.auditRefuseReason }}</span>
         </span>
      </Alert>
      <Card>
        <p slot="title">
          <Icon type="ios-list-outline"></Icon>
          报名详情
        </p>
        <router-link :to="{name: 'sign-list'}" slot="extra">
          <Icon type="ios-paperplane"></Icon>
          返回列表
        </router-link>
        <Form ref="formValidate" class="meeting-form" :model="sign" :label-width="180">
          <div>
            <FormItem v-for="component in companyComponents.componentList" :key="component.id"
                      :label="component.signFormComponent.label">
              <Input v-if="component.signFormComponent.type === 'input'" :value="component.componentValue"></Input>
              <Input v-if="component.signFormComponent.type === 'textarea'" type="textarea" :value="component.componentValue"></Input>

              <Select v-if="component.signFormComponent.type === 'select'" :value="component.componentValue">
                <Option v-for="option in component.signFormComponent.optionsArray" :key="option.id"
                        :value="option.value">{{ option.name }}</Option>
              </Select>
              <RadioGroup v-if="component.signFormComponent.type === 'radio'" :value="component.componentValue">
                <Radio v-for="option in component.signFormComponent.optionsArray" :key="option.id"
                       :label="option.value">{{ option.name }}</Radio>
              </RadioGroup>
              <CheckboxGroup v-if="component.signFormComponent.type === 'checkbox'" :value="getValueArray(component.componentValue)">
                <Checkbox v-for="option in component.signFormComponent.optionsArray" :key="option.id"
                          :label="option.value">{{ option.name }}</Checkbox>
              </CheckboxGroup>
              <div>
                <img v-if="component.signFormComponent.type === 'uploadImg'"
                     :src="`/api/admin/meetings/cover/show?path=${component.componentValue}`" style="max-width: 100%"></img>
              </div>
              <div v-if="component.signFormComponent.type === 'uploadConfigImg'">
                <div v-for="(fileInfo, index) in parseValue(component.componentValue)" :key="index" style="display: inline-block; margin: 5px;">
                  <img :src="`/api/admin/meetings/cover/show?path=${fileInfo.mediaLink}`" style="max-height: 200px; border: 1px solid #ddd; border-radius: 4px;"/>
                </div>
              </div>
            </FormItem>

            <FormItem v-for="component in attendeeComponents.componentList" :key="component.id"
                      :label="component.signFormComponent.label">
              <Input v-if="component.signFormComponent.type === 'input'" :value="component.componentValue"></Input>
              <Input v-if="component.signFormComponent.type === 'textarea'" type="textarea" :value="component.componentValue"></Input>

              <Select v-if="component.signFormComponent.type === 'select'" :value="component.componentValue">
                <Option v-for="option in component.signFormComponent.optionsArray" :key="option.id"
                        :value="option.value">{{ option.name }}</Option>
              </Select>
              <RadioGroup v-if="component.signFormComponent.type === 'radio'" :value="component.componentValue">
                <Radio v-for="option in component.signFormComponent.optionsArray" :key="option.id"
                       :label="option.value">{{ option.name }}</Radio>
              </RadioGroup>
              <CheckboxGroup v-if="component.signFormComponent.type === 'checkbox'" :value="getValueArray(component.componentValue)">
                <Checkbox v-for="option in component.signFormComponent.optionsArray" :key="option.id"
                          :label="option.value">{{ option.name }}</Checkbox>
              </CheckboxGroup>
              <div>
                <img v-if="component.signFormComponent.type === 'uploadImg'"
                     :src="`/api/admin/meetings/cover/show?path=${component.componentValue}`" style="max-width: 100%"></img>
              </div>
              <div v-if="component.signFormComponent.type === 'uploadConfigImg'">
                <div v-for="(fileInfo, index) in parseValue(component.componentValue)" :key="index" style="display: inline-block; margin: 5px;">
                  <img :src="`/api/admin/meetings/cover/show?path=${fileInfo.mediaLink}`" style="max-height: 200px; border: 1px solid #ddd; border-radius: 4px;"/>
                </div>
              </div>
            </FormItem>
            <FormItem label="联系人电话">
                <Input :value="sign.contactPhone"/>
              </FormItem>
            <FormItem label="联系人邮箱">
              <Input :value="sign.contactEmail"/>
            </FormItem>
          </div>
          <p>
            <FormItem>
              <Button type="success" style="float: right" size="large" :disabled="saving" @click="showAuditModal('pass')">审核通过</Button>
              <Button type="error" style="float: right; margin-right: 20px" size="large" :disabled="saving" @click="showAuditModal('refuse')">审核拒绝</Button>
              <!--<Button type="primary" size="large" :disabled="saving" @click="save">保存信息</Button>-->
            </FormItem>
          </p>
        </Form>
      </Card>
      <Modal
          v-model="showModal"
          :title="getAuditModalTitle()"
          :mask-closable="false"
          :loading="modalLoading"
          @on-ok="confirmAuditSign()"
          :styles="{top: '10px'}"
          width="700"
      >
        <Form ref="auditFormValidate" label-position="top" :model="notification" :rules="auditRules">
          <FormItem label="通知方式" prop="by">
            <CheckboxGroup v-model="notification.by">
              <Checkbox label="mobile">短信</Checkbox>
              <Checkbox label="email">邮件</Checkbox>
            </CheckboxGroup>
          </FormItem>
          <FormItem v-if="notification.by.includes('mobile')" label="短信内容" prop="mobileText" :rules="{required: true, message: '请输入短信内容'}">
            <Input v-model.trim="notification.mobileText" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="请输入短信内容"></Input>
          </FormItem>
          <FormItem v-if="notification.by.includes('email')"  label="邮件标题" prop="emailTitle"  :rules="{required: true, message: '请输入邮件标题'}">
            <Input v-model.trim="notification.emailTitle" size="large" placeholder="请输入邮件标题" style="margin-bottom: 10px"></Input>
          </FormItem>
          <FormItem v-if="notification.by.includes('email')" prop="emailText" label="邮件内容" :rules="{required: true, message: '请输入邮件内容'}">
            <tinymce v-if="showModal" id="emailText" v-model.trim="notification.emailText" :other_options="tinymceOptions"></tinymce>
          </FormItem>
        </Form>
      </Modal>
    </div>
  </div>
</template>
<script>

import Vue from 'vue'
import moment from 'moment'
import tinymce from './components/TinymceVue'

export default {
  name: 'SignDetail',
  props: ['meetingId', 'id'],
  components: {tinymce},
  data () {
    return {
      remoteStatus: null,
      saving: false,
      sign: {},
      meeting: {},
      refuseReason: null,
      showModal: false,
      modalLoading: true,
      attendeeComponents: {},
      companyComponents: {},
      notification: {
        by: ['mobile', 'email'],
        mobileText: '',
        emailText: '',
        emailTitle: '',
        receivers: [],
        type: 'pass',
        isBatch: false
      },
      notificationText: {
        mobileTextPass: '',
        mobileTextRefuse: '',
        emailTextPass: '',
        emailTextTitlePass: '',
        emailTextRefuse: '',
        emailTextTitleRefuse: ''
      },
      tinymceOptions: {
        menubar: 'edit insert view format table tools',
        theme: 'modern',
        height: 150,
        relative_urls: false,
        images_upload_url: '/api/admin/cms/articles/img/upload',
        images_upload_base_path: '/api/admin/cms/articles/img/show?path=',
        paste_data_images: true,
        branding: false,
        table_default_styles: {
          width: '100%',
          borderCollapse: 'collapse'
        }
      },
      auditRules: {
        by: [
          {required: false, message: '请选择一种通知方式'}
        ]
      }
    }
  },
  computed: {
    alertType () {
      let status = this.sign.signStatus
      if (status === 0) {
        return 'info'
      } else if (status === 1) {
        return 'success'
      } else if (status === 2) {
        return 'error'
      }
      return 'info'
    }
  },
  methods: {
    getValueArray (val) {
      return JSON.parse(val)
    },
    getStatusText (status) {
      if (status === 0) {
        return '待审核'
      } else if (status === 1) {
        return '审核通过'
      } else if (status === 2) {
        return '审核拒绝'
      }
      return ''
    },
    formatDate (timestamp) {
      if (timestamp) {
        return moment(timestamp).format('YYYY-MM-DD HH:mm:ss')
      } else {
        return null
      }
    },
    setSign (signAttendee) {
      this.sign = signAttendee
      this.attendeeComponents = this.meeting.signSetting.signMeetingSteps[1]
      this.composeComponentAndValues(this.attendeeComponents, this.sign)
      this.companyComponents = this.meeting.signSetting.signMeetingSteps[0]
      this.composeComponentAndValues(this.companyComponents, this.sign)
    },
    composeComponentAndValues: function (signMeetingStep, signAttendee) {
      signMeetingStep.componentList.forEach(function (signMeetingComponent) {
        signAttendee.componentValueList.forEach(function (signMeetingComponentValue) {
          if (signMeetingComponentValue.signMeetingComponentId === signMeetingComponent.id) {
            Vue.set(signMeetingComponent, 'componentValue', signMeetingComponentValue.componentValue)
            if (signMeetingComponent.signFormComponent.type === 'checkbox') {
              // 多选框只能绑定数组
              Vue.set(signMeetingComponent, 'componentValuesOfMultiSelect', JSON.parse(signMeetingComponentValue.componentValue))
            }
          }
        })
      })
    },
    beforeSave () {
      this.$Message.destroy()
      this.$Loading.start()
      this.saving = true
    },
    afterSave (e) {
      this.$Loading.finish()
      if (e) {
        this.$Message.error({
          content: e.body.error || '操作失败，请重试',
          duration: 0,
          closable: true
        })
      } else {
        this.$Message.success('操作成功！')
      }
      this.saving = false
    },
    getAuditModalTitle () {
      if (this.notification.type === 'pass') {
        return `审核通过并发送通知`
      } else if (this.notification.type === 'refuse') {
        return `审核拒绝并发送通知`
      }
    },
    confirmAuditSign () {
      let validPass = false
      this.$refs['auditFormValidate'].validate((valid) => {
        if (valid) {
          validPass = true
        } else {
          validPass = false
        }
      })

      console.log(validPass)

      if (!validPass) {
        this.modalLoading = false
        this.$nextTick(() => {
          this.modalLoading = true
        })
        return
      }

      if (this.notification.type === 'pass') {
        this.auditPass(this.notification.receivers[0])
      } else if (this.notification.type === 'refuse') {
        this.auditRefuse(this.notification.receivers[0])
      }

      this.showModal = false
    },
    setMessages (messages) {
      this.notificationText.mobileTextPass = messages['mobilePassText']
      this.notificationText.mobileTextRefuse = messages['mobileRefuseText']
      this.notificationText.emailTextPass = messages['emailPassText']
      this.notificationText.emailTextTitlePass = messages['emailPassTextTitle']
      this.notificationText.emailTextRefuse = messages['emailRefuseText']
      this.notificationText.emailTextTitleRefuse = messages['emailRefuseTextTitle']
    },
    showAuditModal (type) {
      this.notification.type = type
      this.notification.receivers = [this.sign.id]

      if (type === 'pass') {
        this.notification.mobileText = this.notificationText.mobileTextPass
        this.notification.emailText = this.notificationText.emailTextPass
        this.notification.emailTitle = this.notificationText.emailTextTitlePass
      } else if (type === 'refuse') {
        this.notification.mobileText = this.notificationText.mobileTextRefuse
        this.notification.emailText = this.notificationText.emailTextRefuse
        this.notification.emailTitle = this.notificationText.emailTextTitleRefuse
      }
      this.showModal = true
    },
    async auditPass () {
      try {
        this.beforeSave()
        this.sign = (await this.$http.put(`/api/admin/meetings/${this.meetingId}/signAttendees/${this.sign.id}/audit/pass`, {notification: this.notification})).body
        this.afterSave()
        if (this.notification.by.includes('mobile')) {
          this.notificationText.mobileTextPass = this.notification.mobileText
        } else if (this.notification.by.includes('email')) {
          this.notificationText.emailTextPass = this.notification.emailText
          this.notificationText.emailTextTitlePass = this.notification.emailTitle
        }
      } catch (e) {
        this.afterSave(e)
      }
    },
    async auditRefuse () {
      try {
        this.beforeSave()
        this.sign = (await this.$http.put(`/api/admin/meetings/${this.meetingId}/signAttendees/${this.sign.id}/audit/refuse`, {notification: this.notification, refuseReason: '默认'})).body
        this.afterSave()

        if (this.notification.by.includes('mobile')) {
          this.notificationText.mobileTextRefuse = this.notification.mobileText
        } else if (this.notification.by.includes('email')) {
          this.notificationText.emailTextRefuse = this.notification.emailText
          this.notificationText.emailTextTitleRefuse = this.notification.emailTitle
        }
      } catch (e) {
        this.afterSave(e)
      }
    },
    parseValue: function (componentValue) {
      if (!componentValue) return []
      try {
        return JSON.parse(componentValue)
      } catch (e) {
        return []
      }
    },
    formatFileSize (bytes) {
      if (bytes === 0) return '0 Bytes'
      const k = 1024
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
    }
  },
  async beforeRouteEnter (to, from, next) {
    try {
      let resp = await Vue.http.get(`/api/admin/meetings/${to.params.meetingId}/signAttendees/${to.params.id}`)
      let meeting = (await Vue.http.get(`/api/admin/meetings/${to.params.meetingId}`)).body
      let messages = (await Vue.http.get(`/api/admin/meetings/${to.params.meetingId}/notification/messages`)).body

      next(vm => {
        vm.remoteStatus = resp.status
        vm.meeting = meeting
        vm.setSign(resp.body)
        vm.setMessages(messages)
      })
    } catch (e) {
      next(vm => {
        vm.remoteStatus = e.status
        vm.sign = {}
        vm.meeting = {}
      })
    }
  },
  async beforeRouteUpdate (to, from, next) {
    try {
      let resp = await Vue.http.get(`/api/admin/meetings/${this.meetingId}/signAttendees/${this.id}`)
      let meeting = (await Vue.http.get(`/api/admin/meetings/${this.meetingId}`)).body
      let messages = (await Vue.http.get(`/api/admin/meetings/${this.meetingId}/notification/messages`)).body

      this.remoteStatus = resp.status
      this.meeting = meeting
      this.setSign(resp.body)
      this.setMessages(messages)
      next()
    } catch (e) {
      this.remoteStatus = e.status
      this.sign = {}
      this.meeting = {}
      next()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/meeting/SignDetail.vue